(function() {
  function updateCartQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.item_count !== undefined) {
        window.location.href = window.location.href;
      }
    })
    .catch(function(e) { console.error('Cart update failed:', e); });
  }

  function initQuantityFix() {
    document.querySelectorAll('.quantity-selector__button').forEach(function(btn) {
      if (btn.dataset.fixApplied) return;
      btn.dataset.fixApplied = 'true';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var action = btn.getAttribute('data-action'); // "increase-quantity" or "decrease-quantity"
        var container = btn.closest('.quantity-selector') || btn.parentElement;
        var input = container.querySelector('.quantity-selector__value, input[type="number"]');
        if (!input) return;

        var line = parseInt(input.getAttribute('data-line')) || 1;
        var current = parseInt(input.value) || 1;
        var newQty = (action === 'increase-quantity') ? current + 1 : Math.max(1, current - 1);

        input.value = newQty;
        input.setAttribute('data-current-value', newQty);

        updateCartQuantity(line, newQty);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityFix);
  } else {
    initQuantityFix();
  }
})();